import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { Users, Target, Activity, ClipboardCheck, ArrowRight } from "lucide-react";
import { marketing, useMarketingLocale } from "@/i18n/marketing";

export const WhyItWorks = () => {
  const locale = useMarketingLocale();
  const t = marketing.home[locale].whyItWorks;

  // Docs page is currently English-only — link there regardless of locale.
  const cards = [
    { icon: Users, title: t.card1Title, excerpt: t.card1Body, link: "/docs#voting-psychology" },
    { icon: Target, title: t.card2Title, excerpt: t.card2Body, link: "/docs#voting-pedagogy" },
    { icon: Activity, title: t.card3Title, excerpt: t.card3Body, link: "/docs#rpe-science" },
    { icon: ClipboardCheck, title: t.card4Title, excerpt: t.card4Body, link: "/docs#attendance" },
  ];

  return (
    <motion.div
      className="py-16"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay: 0.4 }}
    >
      <div className="max-container">
        <div className="text-center mb-12">
          <h2 className="heading-2 mb-3 text-foreground">{t.heading}</h2>
          <p className="text-xl text-muted-foreground max-w-2xl mx-auto">
            {t.subhead}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {cards.map((card) => (
            <div
              key={card.title}
              className="bg-card border rounded-xl p-8 shadow-sm flex flex-col"
            >
              <div className="w-12 h-12 rounded-full bg-primary/10 text-primary flex items-center justify-center mb-4">
                <card.icon className="w-6 h-6" />
              </div>
              <h3 className="text-xl font-bold mb-2 text-foreground">
                {card.title}
              </h3>
              <p className="text-muted-foreground mb-4 flex-1">
                {card.excerpt}
              </p>
              <Link
                to={card.link}
                className="inline-flex items-center gap-1 text-sm font-medium text-primary hover:underline"
              >
                {t.learnMore} <ArrowRight className="w-4 h-4" />
              </Link>
            </div>
          ))}
        </div>

        <div className="text-center mt-10">
          <Link
            to="/docs"
            className="inline-flex items-center gap-2 text-sm font-medium text-primary hover:underline"
          >
            {t.methodologyLink} <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
      </div>
    </motion.div>
  );
};
